import { IconAlertTriangleFilled } from '@tabler/icons-react';
import { useFela } from 'react-fela';
import { useIntl } from 'react-intl';

import type { Theme } from '@/styles/theme';

import * as felaRules from './SecurityAuditWarningIcon.rules';

export const SecurityAuditWarningIcon = () => {
    const { css, theme } = useFela<Theme>();
    const { formatMessage } = useIntl();

    const label = formatMessage({ id: 'securityAudit.indicator.label' });

    return (
        <IconAlertTriangleFilled
            role='img'
            aria-label={label}
            title={label}
            size={20}
            color={theme.colors.foregroundsDestructive}
            className={css(felaRules.icon)}
        />
    );
};
